/**
 * Lane P3d additions to `store/selectors.ts`.
 *
 * Kept in a separate module purely so four UI lanes could land in parallel
 * without colliding on one 1400-line file. Fold it back into `selectors.ts`
 * when the lanes merge — there is nothing structurally different about it.
 *
 * One helper is left here:
 *  - `dragGhostVM` — `store.drag` (ui slice) carries only `{zone,row,id,name}`,
 *    but the ghost paints the same 2/3 cover the board capsule did, so it has
 *    to re-derive the tile.
 *
 * The lane's second helper, `clearFilterChip`, was a confirmed duplicate of
 * `selectors.3c.ts#removeChip` (P3d D-3). The seam is closed: `removeChip` is
 * the survivor and all four chip-rail screens call it.
 */

import { tileVM } from '../lib/logic.ts';
import type { ArtCand } from '../lib/types.ts';
import type { QdStore } from './types.ts';

export interface DragGhostVM {
  show: boolean;
  name: string;
  fall: string;
  ini: string;
  coverCands: ArtCand[];
}

const EMPTY: DragGhostVM = { show: false, name: '', fall: 'var(--gt-field)', ini: '', coverCands: [] };

/** `sheets/DragGhost.tsx` — prototype lines 1260-1267 + `dragActivate` line 1324. */
export function dragGhostVM(s: QdStore): DragGhostVM {
  const d = s.drag;
  if (!d) return EMPTY;
  const g = s.gById(d.id);
  if (!g) return { ...EMPTY, show: true, name: d.name };
  const t = tileVM(g, { listIds: new Set(s.list.map((e) => e.id)), assets: s.assets });
  return { show: true, name: d.name, fall: t.fall, ini: t.ini, coverCands: t.coverCands };
}
